import  React, {Component} from 'react';
import { Form, Container, Button, Table, Modal, Alert } from 'react-bootstrap';
import UserSummary from '../UserSummary/UserSummary';
import AuthUser from '../Auth/Auth'
import './ViewRequest.css';
import UserContext from '../../context/user-context';
import Loading from '../UI/Spinner/Spinner';
//import WorkOrder from '../../WorkOrder.json';
import axios from '../../axios-private-http.js';
import ReactToPrint from "react-to-print";
import PrintWorkorder from '../Print/PrintWorkOrder';
import Aux from '../../hoc/_Aux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ViewRequest extends Component {

    static contextType = UserContext;

     woIdToDelete = "";
     woIdForEmailConfirmation ="";

    state = {
        token: "",
        workOrderList: [],
        errorMessage: "",
        errorHeader:"",
        loading: false,
        setShowCancelModal: false,
        setShowEmailModal: false,
        emailConfirmationValue:"",
        emailConfirmErrorVisibility:false,
        woStatus: "",
        woToPrint:""
    }

    componentDidMount() {
        if (sessionStorage.getItem('Loc') == null ) {
        this.props.history.push('/');
       } else {
       // const {token} = this.context;
        this.setState({loading : true});
       // if(token.length <= 0 ) {
        AuthUser.getSFToken(sessionStorage.getItem('Seg'), this.setSFToken, this.setSFTokenError);
       // } else {
        //    this.getHistoricalWorkOrders();
       // }
    }
    }

    setSFToken = (token) => {
        const {setSFToken} = this.context;
        this.setState({token: token});
        setSFToken(token);
        this.getHistoricalWorkOrders();
    } 

    setSFTokenError = (errorMessage) => {
        this.setState({loading : false});
        this.setState({errorHeader: "Error"})
        this.setState({errorMessage: errorMessage});
    }

    getHistoricalWorkOrders = () => {
        if (!this.state.loading) {
            this.setState({loading : true});
        }
        const locationId = sessionStorage.getItem('Loc');
        const payLoad = {
            "ServiceProviderName": ""+process.env.REACT_APP_SERVICE_PROVIDER_NAME+"",
            "customerLocationId":""+locationId+""
        }
        axios(this.state.token).post( '/exportWebWorkOrder', JSON.stringify(payLoad))
        .then( response => {
            if (response.data.StatusCode === "200") {
               if(response.data.Records.length !== 0) {
                this.setState({workOrderList: response.data.Records});
                this.setState({errorHeader: ""});
                this.setState({errorMessage: ""});
               } else {
                this.setState({errorHeader: "No service request"});
                this.setState({errorMessage: "You have not made a service request yet."});
               }

            } else if(response.data.StatusCode === "400") {
                this.setState({errorHeader: "Error"});
                this.setState({errorMessage: response.data.Message});
            } else {
                this.setState({errorHeader: "No service request"});
                this.setState({errorMessage: "You have not made a service request yet."});
            }
            this.setState({loading : false});
        })
        .catch(error => {
            this.setState({loading : false});
            this.setState({errorHeader: "Error"})
            this.setState({errorMessage: "Something went wrong."});
        });
    }

    onCancelButtonClicked = (event) => {
        this.setState({woStatus: event.target.name});
        this.woIdToDelete = event.target.value;
        this.setState({setShowCancelModal: true});
    }

    onModalClose = () => {
        this.setState({setShowCancelModal: false});
    }

    onEmailModalClose = () => {
        this.setState({setShowEmailModal: false});
    }

    onSendConfirmationEmailButtonClicked =(event) => {
        this.woIdForEmailConfirmation = event.target.value;
        this.setState({setShowEmailModal: true});
    }

    onCreateNewRequestButtonClick = () => {
        this.props.history.push('/create-request');
    }

    onModalCancelClicked = (event) => {
        this.onModalClose();
        const locationId = sessionStorage.getItem('Loc');
        this.setState({loading : true});
        const payLoad = {
                "serviceProviderName":""+process.env.REACT_APP_SERVICE_PROVIDER_NAME+"",
                "customerLocationId":""+locationId+"",
                "workOrderID":""+this.woIdToDelete+"",
                "resolutionCode":"REQ_CANCELLED",
                "WONotes":""
        }
        axios(this.state.token).post( '/cancelWebWorkOrder', JSON.stringify(payLoad))
        .then( response => {
            if (response.data.StatusCode === "200") {
                this.setState({workOrderList: response.data.Records});
                this.setState({errorHeader: ""});
                this.setState({errorMessage: ""});
                toast.success('Service request cancelled successfully', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else if(response.data.StatusCode === "400") {
                this.setState({errorHeader: "Error"});
                this.setState({errorMessage: response.data.Message});
            } else {
                this.setState({errorHeader: "Error"});
                this.setState({errorMessage: "Something went wrong while cancelling the service request."});
            }
            this.setState({loading : false});
        })
        .catch(error => {
            this.setState({loading : false});
            this.setState({errorHeader: "Error"})
            this.setState({errorMessage: "Something went wrong while cancelling the service request."});
        });
    }

    setContentToPrint = (index) => {
       // alert('set content');
        this.setState({woToPrint : this.state.workOrderList[index]});
    }

    onEmailConfirmationChange = (event) => {
        const re = /^[-.@_a-z0-9]+$/gi;
        if (event.target.value === '' || re.test(event.target.value)) {
            this.setState({emailConfirmationValue: event.target.value});
        }
    }

    onEmailSendClick = (event) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(this.state.emailConfirmationValue)) {
            this.setState({emailConfirmErrorVisibility: true});
        } else {
            this.setState({emailConfirmErrorVisibility: false});
            this.onEmailModalClose();
            this.sendConfirmationEmail(this.state.emailConfirmationValue);
        }
    }

    sendConfirmationEmail(email) {
        const payLoad = {
            "email":""+email+"",
            "workOrderId":""+this.woIdForEmailConfirmation +"",
            "billingAccountNumber":""+sessionStorage.getItem('AccountNumber')+""
            }
        axios(this.state.token).post( '/ticketConfirmation', JSON.stringify(payLoad))
        .then( response => {
            if (response.data.StatusCode === "200") {
                this.setState({emailConfirmationValue: ""});
                this.setState({errorHeader: ""});
                this.setState({errorMessage: ""});
                toast.success('Service request emailed successfully', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else if(response.data.StatusCode === "400") {
                this.setState({errorHeader: "Error"});
                this.setState({errorMessage: response.data.Message});
                this.setState({emailConfirmationValue: ""});
                toast.error(response.data.Message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                this.setState({errorHeader: "Error"});
                this.setState({errorMessage: "Something went wrong while sending the service request to the email"});
                this.setState({emailConfirmationValue: ""});
                toast.error("Something went wrong while sending the email", {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        })
        .catch(error => {
            this.setState({loading : false});           
        });

    }

    render() {
        var loadingScreen = "";

        const styleShowHide = {
            display: 'none'
          }

          if (this.state.emailConfirmErrorVisibility) {
            styleShowHide.display = 'block';
          } else {
            styleShowHide.display = 'none';
          }

        if (this.state.loading) {
            loadingScreen = <Loading />;
        }
        var showErrorMessage = "";
        

        if (this.state.errorMessage && this.state.errorMessage !== "") {
            showErrorMessage = (
                <div>
                <br/>
                <Alert variant={this.state.errorHeader === "Error" ? "danger" : "success"}>
                        <div><b>{this.state.errorHeader}</b></div>
                        { this.state.errorMessage}
                </Alert>
                </div>)
        }

        return <Container  className="wrapper">
                 <br/>
                 <UserSummary showEditButton={false} showCreateNewButton = {true} onCreateNewRequestHandler = {this.onCreateNewRequestButtonClick}/>
                    {
                     (this.props.location.state != null && this.props.location.state.woCreated)?   
                     <Alert variant="success">
                        <Alert.Heading>Thank you for submitting your request</Alert.Heading>
                        <p className="alert-margin-bottom">
                            <br/>Requests are generally completed within five business days.<br/><br/>
                            Make sure that your cart is easy to see and access from the street or alley. Place it outside your fenced yard or garage. If your cart is not accessible, your work request will be rescheduled and a missed service fee of <strong>$18.50</strong> may be applied to your utility bill.
                        </p> 
                    </Alert> : null
                 }
               
                <h1 className="header">Your Service Requests</h1>  
                {
                   // (this.state.workOrderList.length < 1) ? (<p>You have not made a service request yet.</p>) : ("")
                }
                <Table striped bordered hover>
                        <tbody>

                        { //this.state.workOrderList
                        //WorkOrder.Records
                        this.state.workOrderList.map((item, index) => (
                                 <tr key={item.WorkOrderID}>
                                     <td>
                                     <div className="row">
                                         <div className="col">Confirmation Number:</div>
                                         <div className="col">{item.workOrderLUID}</div>
                                     </div>
                                     <div className="row">
                                         <div className="col">Order Date:</div>
                                         <div className="col">{item.requestedDate}</div>
                                     </div>
                                     <div className="row">
                                         <div className="col">Service Requested:</div>
                                         <div className="col">{item.requestType}</div>
                                     </div>
                                     {(item.serialNumber === null || item.serialNumber === "") ? null 
                                        :   <div className="row">
                                                <div className="col">Serial Number:</div>
                                                <div className="col">{item.serialNumber}</div>
                                            </div>
                                     }
                                     <div className="row">
                                         <div className="col">Comments:</div>
                                         <div className="col">{item.woNotes}</div>
                                     </div>
                                     </td>                        
                                 <td>
                                     <div className="row">
                                        <div className="col">
                                            <Button variant="custom" type="success" value = {item.workOrderID} name = {item.caseStatus} onClick = {(event) => this.onSendConfirmationEmailButtonClicked(event)} block className="light-grey-button">Email</Button>
                                        </div>
                                     </div>
                                     <div className="row">
                                        <div className="col">
                                            <ReactToPrint
                                                onBeforeGetContent={() => this.setContentToPrint(index)}
                                                trigger={() => { return <Button variant="custom" type="success" onMouseMoveCapture={(event) => this.setContentToPrint(index)} value= {index} block className="light-grey-button">Print</Button>}}
                                                content={() => this.componentRef}
                                                documentTitle = {"Service Request - "+item.workOrderLUID} />
                                        </div>
                                     </div>
                                     <div className="row">
                                        <div className="col">
                                            <Button variant="custom" type="success" value = {item.workOrderID} name = {item.caseStatus} onClick = {(event) => this.onCancelButtonClicked(event)} block className="light-grey-button no-bottom-margin">Cancel</Button>
                                        </div>
                                     </div>
 
                                 </td>
                                 </tr>
                            ))}                           
                        </tbody>
                    </Table>

                    {showErrorMessage}

                    <Modal
                        show = {this.state.setShowCancelModal}
                        onHide={this.onModalClose}
                        backdrop="static"
                        keyboard={false}>

                            <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body> {
                                    (this.state.woStatus === "New" || this.state.woStatus === "Open") ? 
                                        "Are you sure you want to cancel the service request?" : "This request cannot be canceled. It is in progress or has already been completed. Please contact the City to make this request."
                                }
                            </Modal.Body>
                            <Modal.Footer>
                            {(this.state.woStatus === "New" || this.state.woStatus === "Open") ? 
                                <Aux>
                                    <Button variant="primary" onClick={(event) => this.onModalCancelClicked(event) }>Yes</Button>
                                    <Button variant="secondary" onClick={(event) => this.setState({setShowCancelModal: false}) }>No</Button>
                                </Aux> : <Button variant="primary" onClick={(event) => this.setState({setShowCancelModal: false}) }>Ok</Button>
                            }
                            </Modal.Footer>
                    </Modal>

                    <Modal
                        show = {this.state.setShowEmailModal}
                        onHide={this.onEmailModalClose}
                        backdrop="static"
                        keyboard={false}>

                            <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body> 
                                {/* new code - RDI-4285 */}
                                {/* Please enter the recipient's email <p/> */}
                                Please enter your email address <p/>                                
                                 <Form.Control type="text" onChange={(event)=> this.onEmailConfirmationChange(event)} value={this.state.emailConfirmationValue} placeholder= "Email"/>
                                 
                                 <div>
                                    <Alert variant="danger" style={styleShowHide}>
                                        <div className="row">
                                            <b>Error</b> 
                                        </div>
                                        <div className="row">Please enter a valid email</div>
                                    </Alert>
                                 </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Aux>
                                    <Button variant="primary" onClick={(event) => this.onEmailSendClick(event) }>Send</Button>
                                    <Button variant="secondary" onClick={(event) => this.setState({setShowEmailModal: false}) }>Cancel</Button>
                                </Aux> 
                            </Modal.Footer>
                    </Modal>
                    {loadingScreen}

                    <div style={{ display: 'none' }}>
                        <PrintWorkorder woDetails= {this.state.woToPrint}  ref={(event) => (this.componentRef = event)}/>
                    </div>

                    <ToastContainer
                        position="bottom-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                </Container>
    }
};

export default ViewRequest;